import { forwardRef, type ComponentPropsWithoutRef, type ComponentRef } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { twcn } from '@web/ui/core/utils';

/*
 * Label — Radix Label re-export with DS styling.
 *
 * Example: <Label htmlFor="email">Email</Label>
 *
 * Pairs with Input via `htmlFor`. Disabled-aware via peer-disabled selectors.
 */
export const Label = forwardRef<
  ComponentRef<typeof LabelPrimitive.Root>,
  ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(function Label({ className, ...props }, ref) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={twcn(
        'text-meta font-medium leading-none text-foreground',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
        className,
      )}
      {...props}
    />
  );
});
